export const getBase64Img = (x: any) => {
  return `data:image/png;base64,${x}`;
};

const replaceAll = (str: any, a: any, b: any) => {
  return str.split(a).join(b);
};

export const unformatCPF = (cpf: any) => {
  return replaceAll(replaceAll(cpf, '.', ''), '-', '');
};

export const formatCPF = (cpf: any) => {
  const digits = String(cpf).replace(/\D/g, '');
  let formated = '';
  for (let i = 0; i < digits.length; i++) {
    formated += digits[i];
    if (i === 2 || i === 5) formated += '.';
    if (i === 8) formated += '-';
  }
  return formated;
};

export const formatCNPJ = (cnpj: string) => {
  const digits = String(cnpj ?? '').replace(/\D/g, '');
  if (digits.length !== 14 || /^(\d)\1+$/.test(digits)) return '-';
  return digits.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    '$1.$2.$3/$4-$5'
  );
};

export const formatDate = (value?: string) => {
  if (!value) return '—';
  const dateOnly = value.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.0+)?(?:Z|\+00:00)?)?$/
  );
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    const calendarDate = new Date(0);
    calendarDate.setUTCHours(0, 0, 0, 0);
    calendarDate.setUTCFullYear(Number(year), Number(month) - 1, Number(day));
    if (
      calendarDate.getUTCFullYear() === Number(year) &&
      calendarDate.getUTCMonth() === Number(month) - 1 &&
      calendarDate.getUTCDate() === Number(day)
    ) {
      return new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
        calendarDate
      );
    }
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat('pt-BR').format(date);
};
